<div class="wrapper-page">
  <div class="wrapper-header-page">
    <div class="overlay-illustration-header"></div>
  </div>
  <div class="wrapper-content-page">
    <div class="wrapper-header-page-content">
      <span class="header-text">{{pageId | handlePageTitlePipe}}</span>
    </div>
    <div *ngIf="pageId === '3'" class="grid__m-12">
      <div class="zc-wrapper-tabs">
        <div class="zc-tab" [ngClass]="{'active': aboutUsActiveTab === AboutUsTabEnums.mobile}" (click)="aboutUsActiveTab = AboutUsTabEnums.mobile">
          <span>Mobilna applikacija</span>
        </div>
        <div class="zc-tab" [ngClass]="{'active': aboutUsActiveTab === AboutUsTabEnums.landing}" (click)="aboutUsActiveTab = AboutUsTabEnums.landing">
          <span>Landing</span>
        </div>
      </div>
    </div>
    <form *ngIf="pageId !== '3' || (pageId === '3' && aboutUsActiveTab !== AboutUsTabEnums.landing)" [formGroup]="updatePageForm" (ngSubmit)="submitUpdatePageForm()">
      <div class="wrapper-quill-editor">
        <quill-editor [formControl]="updatePageForm.controls.content | formControl" [ngClass]="{'not-allowed': isFormDisabled}"></quill-editor>
        <span class="error-message">{{updatePageForm.controls.content | formControlErrorMessages: null : formTriedToSubmit}}</span>
      </div>
      <div class="wrapper-save-btn">
        <button *ngIf="isFormDisabled" (click)="enableForm()" class="zc-btn zc-btn--primary xs-mr-32 xs-mt-10" type="button">
          <span>{{isPageCreated ? 'Izmeni' : 'Dodaj'}}</span>
        </button>
        <button *ngIf="!isFormDisabled" class="zc-btn zc-btn--primary" type="submit">
          <span>Sačuvaj</span>
        </button>
      </div>
    </form>
    <form *ngIf="pageId === '3' && aboutUsActiveTab === AboutUsTabEnums.landing" [formGroup]="aboutUsGalleryForm" (ngSubmit)="submitEditBusinessProfileForm()">
      <div class="grid__m-12">
        <div class="wrapper-custom-gallery">
          <div class="header-custom-gallery">
            <span class="title-gallery">Galerija</span>
            <div class="wrapper-btn-gallery">
              <div class="file-input">
                <input
                  #fileInput
                  type="file"
                  accept=".jpg,.jpeg,.png,.svg"
                  name="file-input"
                  id="file-input"
                  [disabled]="isAboutUsGalleryFormDisabled"
                  class="file-input__input"
                  multiple
                  (change)="onFileChange($event)"
                />
                <label [ngClass]="{'not-allowed': isAboutUsGalleryFormDisabled}" class="file-input__label"
                       for="file-input"><span>Dodaj galeriju</span></label>
              </div>
              <button (click)="removeAllImages()" [disabled]="isAboutUsGalleryFormDisabled"
                      [ngClass]="{'not-allowed': isAboutUsGalleryFormDisabled}" class="zc-btn zc-btn--delete"
                      type="button"><span>Obriši sve slike</span></button>
            </div>
          </div>
          <div class="content-custom-gallery">
            <div class="wrapper-gallery-images">
              <div *ngFor="let imgUrl of imageUrls" class="wrapper-gallery-image">
                <img [src]="imgUrl.fullPath" alt="">
                <span [ngClass]="{'not-allowed': isAboutUsGalleryFormDisabled}" class="icon-delete"
                      (click)="removeSingleImage(imgUrl)">
                      <i class="fa-regular fa-trash-can"></i>
                    </span>
              </div>
            </div>
          </div>
          <span class="error-message">{{ aboutUsGalleryForm.controls.images | formControlErrorMessages: null : formTriedToSubmit }}</span>
        </div>
      </div>
      <div class="wrapper-save-btn">
        <button *ngIf="isAboutUsGalleryFormDisabled" (click)="enableAboutUsGalleryForm()" class="zc-btn zc-btn--primary xs-mr-32 xs-mt-10" type="button">
          <span>{{imageUrls?.length ? 'Izmeni' : 'Dodaj'}}</span>
        </button>
        <button *ngIf="!isAboutUsGalleryFormDisabled || isLoaderActive" class="zc-btn zc-btn--primary zc-position-relative" type="submit">
          <gr-loader *ngIf="isLoaderActive" [isButtonLoader]="true"></gr-loader>
          <span>Sačuvaj</span>
        </button>
      </div>
    </form>
  </div>
</div>
